import axios from 'axios'
import { useAuthStore } from '../store/auth'
import { request } from 'http'

const { REACT_APP_API_LOCAL } = process.env

export const api = axios.create({
  baseURL: REACT_APP_API_LOCAL,
  headers: {
    Accept: 'application/json', 
  },
})

api.interceptors.request.use(
  async (config) => {
    
    const token = useAuthStore.getState().token
    config.headers.set('Authorization', `Bearer ${token}`)
    
    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

api.interceptors.response.use(
  (response) => {
    
    return response
  },
  (error) => {
    if (error.response.status === 401) {
      useAuthStore.getState().logout()
    }
    return Promise.reject(error)
  },
)
